// Lightweight fallback to ensure mobile menu opens in system tests
// when Stimulus didn't bind yet for any reason. It only activates if
// the page contains a button with aria-label="Open sidebar" and a menu
// container with data-mobile-menu-target="menu".

document.addEventListener("DOMContentLoaded", () => {
  try {
    const openBtn = document.querySelector("button[aria-label='Open sidebar']")
    const menu = document.querySelector('[data-mobile-menu-target="menu"]')
    const overlay = document.querySelector('[data-mobile-menu-target="overlay"]')
    const panel = document.querySelector('[data-mobile-menu-target="panel"]')

    if (!openBtn || !menu) return

    // Skip if Stimulus already connected (controller adds dataset attribute)
    const isStimulusPresent = !!document.querySelector('[data-controller~="mobile-menu"]')

    // Bind only if Stimulus controller is not present or not connected yet
    openBtn.addEventListener("click", () => {
      // If Stimulus handled this, do nothing
      if (isStimulusPresent && menu.classList.contains("translate-x-0")) return

      // Show menu
      menu.classList.remove("hidden")
      if (overlay) {
        overlay.classList.remove("opacity-0")
        overlay.classList.add("opacity-100")
      }
      if (panel) {
        panel.classList.remove("-translate-x-full")
        panel.classList.add("translate-x-0")
      }
      document.body.style.overflow = "hidden"
    })

    const closeBtn = document.querySelector("button[aria-label='Close sidebar']")
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        if (overlay) {
          overlay.classList.remove("opacity-100")
          overlay.classList.add("opacity-0")
        }
        if (panel) {
          panel.classList.remove("translate-x-0")
          panel.classList.add("-translate-x-full")
        }
        setTimeout(() => menu.classList.add("hidden"), 300)
        document.body.style.overflow = ""
      })
    }

    if (overlay) {
      overlay.addEventListener("click", (e) => {
        if (e.target !== e.currentTarget) return
        if (panel) panel.classList.add("-translate-x-full")
        overlay.classList.add("opacity-0")
        setTimeout(() => menu.classList.add("hidden"), 300)
        document.body.style.overflow = ""
      })
    }
  } catch (e) {
    // Fail silently in production
  }
})

